export default __webpack_public_path__ + "static/media/bookmark-saved.e38bcdf0.svg";